<template>
    <div class="flex-grow-1 of-y d-flex" style="position: relative">
        <template v-if="startingUp">
            <div class="d-flex align-center justify-center fill-height flex-grow-1">
                <loader :size="52"></loader>
            </div>
        </template>
        <template v-else>
            <div class="flex-grow-1 of-y d-flex flex-column" style="min-width: 25%; max-width: 25%">
                <div class="text-center primary--text overline pt-2 pb-1"
                     style="border-bottom: 2px solid var(--v-primary-base); font-size: 14px !important;">
                    <div style="height: 2px"></div>
                    Recruitment Fields
                </div>
                <div class="flex-grow-1 of-y pa-2">
                    <v-form ref="recruitment" @submit="$event.preventDefault()" :readonly="!recruitment.export">
                        <div
                                v-for="(field, i) in fieldsToUse"
                                :key="field.value || i"
                                class="pb-2"
                        >

                            <div class="pa-2 grey--text" v-if="field.title">
                                {{field.text}}
                            </div>

                            <v-autocomplete
                                    v-else-if="field.value === 'gender'"
                                    :label="field.text"
                                    v-model="recru[field.value]"
                                    :items="['M', 'F']"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    :rules="getRules(field.value)"
                                    @focusin="selectedProp = field.value"
                                    :ref="field.value"
                            >
                            </v-autocomplete>
                            <v-autocomplete
                                    v-else-if="field.value === 'nationality'"
                                    :label="field.text"
                                    v-model="recru[field.value]"
                                    :items="nationalityOptions"
                                    item-text="description"
                                    item-value="id"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    :rules="getRules(field.value)"
                                    @focusin="selectedProp = field.value"
                                    :ref="field.value"
                            >
                            </v-autocomplete>
                            <v-autocomplete
                                    v-else-if="field.value === 'bankName'"
                                    :label="field.text"
                                    v-model="recru[field.value]"
                                    :items="bankOptions"
                                    item-text="description"
                                    item-value="id"
                                    outlined
                                    dense
                                    @focusin="selectedProp = field.value"
                                    :ref="field.value"
                                    hide-details="auto"
                                    :rules="getRules(field.value)"
                            >
                            </v-autocomplete>
                            <v-autocomplete
                                    v-else-if="field.value === 'position'"
                                    :label="field.text"
                                    v-model="recru[field.value]"
                                    :items="jobDescriptions"
                                    outlined
                                    dense
                                    @focusin="selectedProp = field.value"
                                    :ref="field.value"
                                    hide-details="auto"
                                    :rules="getRules(field.value)"
                            >
                            </v-autocomplete>
                            <v-text-field
                                    v-else-if="field.value === 'dob'"
                                    :label="field.text"
                                    placeholder="YYYY-MM-DD"
                                    persistent-placeholder
                                    v-model.trim="recru[field.value]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    @focusin="selectedProp = field.value"
                                    :ref="field.value"
                                    :rules="getRules(field.value)"
                            ></v-text-field>
                            <v-text-field
                                    v-else
                                    :label="field.text"
                                    v-model.trim="recru[field.value]"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    @focusin="selectedProp = field.value"
                                    :ref="field.value"
                                    :rules="getRules(field.value)"
                            ></v-text-field>
                        </div>
                    </v-form>
                </div>
            </div>

            <div class="green" style="">
                <divider :vertical="true"></divider>
            </div>

            <div class="d-flex flex-column fill-height" style="width: 75%">
                <div>
                    <v-tabs v-model="viewIndex" grow class="flex-grow-1">
                        <v-tab :value="0" >Identification Document</v-tab>
                        <v-tab :value="1" >Recruitment Form</v-tab>
                        <v-tab :value="2" >Face Photo</v-tab>
                        <v-tab :value="3" v-if="recruitment.fkBankingDoc">Proof of Bank</v-tab>
                        <v-tab :value="4" v-if="recruitment.fkClockDoc">Clock Card</v-tab>
                        <v-tab :value="5" v-if="recruitment.fkIdDocBack">ID Document Back</v-tab>
                        <v-tab :value="6" v-if="recruitment.fkOperatorCard">Operator Card</v-tab>
                    </v-tabs>
                </div>
                <div>
                    <divider/>
                </div>
                <div class="flex-grow-1 d-flex of-y" style="position: relative">

                    <div class="flex-grow-1 pa-2 fill-height of-y">

                        <div v-for="(str, i) in metaInfo" class="pb-2">
                            <v-card
                                    hover
                                    ripple
                                    class="py-1 pl-2 pr-1 primary white--text"
                                    style="display: inline-block;"
                                    @click="chipClicked(str)"
                                    :disabled="!recruitment.export"
                            >
                                <div class="d-flex align-center">
                                    <div class="pr-1">
                                        {{ str }}
                                    </div>
                                    <v-btn
                                            icon
                                            small
                                            color="white"
                                            @click.stop="removeWord(str)"
                                    >
                                        <v-icon>mdi-close-circle</v-icon>
                                    </v-btn>
                                </div>
                            </v-card>
                        </div>
                    </div>

                    <div>
                        <divider :vertical="true"/>
                    </div>



                    <div
                            style="width: 80%; max-width: 80%; min-width: 80%; overflow: hidden; height: 100%;
                            background: rgb(225,225,225);
                            position: relative"
                            class=""
                            ref="displayImageBox"
                            @mousedown="mouseDownImage"
                            @wheel="mouseWheel"
                    >



                        <div v-if="loadingImage" class="d-flex align-center justify-center" style="position: absolute; width: 100%; height: 100%; left: 0; top: 0">
                            <loader :size="52"></loader>
                        </div>

                        <img
                                :draggable="false"
                                ref="displayImage"
                                style="object-fit: contain; position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); cursor: grab"
                                :src="viewInfo.url"
                                alt="image"
                                @load="loadingImage = false"
                                :style="{
                                    opacity: loadingImage ? 0 : 1,
                                    height: (100 * zoomRatio) + '%',
                                    width: (100 * zoomRatio) + '%',
                                }"
                        >
                    </div>

                    <div style="position: absolute; right: 0; top: 0" class="pa-3">
                        <v-menu left offset-x nudge-left="10">
                            <template v-slot:activator="{on}">
                                <v-btn
                                        fab
                                        small
                                        color="secondary"
                                        v-on="on"
                                        class="mx-2"
                                >
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <v-card style="width: 350px">

                                <div class="white--text pa-2 primary">
                                    Zoom Options
                                </div>

                                <div class="d-flex align-center justify-space-around px-3 pt-3">
                                    <v-btn
                                            color="secondary"
                                            small
                                            text
                                            @click="fitWidth"
                                    >
                                        <v-icon left>mdi-arrow-expand-horizontal</v-icon>
                                        Fit Width
                                    </v-btn>

                                    <v-btn
                                            color="secondary"
                                            small
                                            text
                                            @click="resetImage"
                                    >
                                        <v-icon left>mdi-restore</v-icon>Reset
                                    </v-btn>

                                    <v-btn
                                            color="secondary"
                                            small
                                            text
                                            @click="fitHeight()"
                                    >
                                        <v-icon left>mdi-arrow-expand-vertical</v-icon>
                                        Fit Height
                                    </v-btn>
                                </div>

                                <v-slider
                                        :max="5"
                                        :min="0.2"
                                        :step="0.05"
                                        color="primary"
                                        track-color="primary"
                                        thumb-label
                                        :thumb-size="30"
                                        v-model="zoomRatio"
                                        class="mt-5 px-3 pb-3"
                                        hide-details
                                >
                                    <template #label>
                                        <span class="body-2 display--text">Zoom</span>
                                    </template>
                                    <template #thumb-label="{value}">
                                        <span class="caption">{{ Math.floor(value * 100) }}</span>
                                    </template>
                                    <template #append>
                                        <span class="body-2 display--text">{{ Math.floor(zoomRatio * 100) }}%</span>
                                    </template>
                                </v-slider>
                            </v-card>
                        </v-menu>
                    </div>
                </div>
            </div>
        </template>

        <div style="position: absolute; bottom: 0; right: 0" class="pa-3">
            <v-btn
                    large
                    color="white"
                    icon
                    class="secondary"
                    @click="saveChanges"
            >
                <v-icon>mdi-content-save</v-icon>
            </v-btn>
        </div>

        <DownloadImages
                v-if="showDownload"
                :recruitment="recruitment"
                :identityUrl="identityUrl"
                :identityBackUrl="identityBackUrl"
                :recruitmentUrl="recruitmentUrl"
                :photoUrl="photoUrl"
                :clockUrl="clockUrl"
                :bankingUrl="bankingUrl"
                :shown.sync="showDownloadRelay"
        >

        </DownloadImages>

    </div>
</template>

<script>
import Loader from "../General/Loader/Loader";
import Divider from "../General/Divider";
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue'
import DownloadImages from "@/components/Recruitment/DownloadImages";
import {arrSplice, objectifyArr, validationRules} from "@/core/codeFunctions";
import {format} from "date-fns";
import {mapGetters} from "vuex";

Vue.use(VueViewer)
export default {
    components: {DownloadImages, Divider, Loader},
    props: {
        shown: Boolean,
        recruitment: Object,
        showDownload: Boolean,
    },
    data() {
        return {
            loadingImage: false,
            console,
            savingChanges: false,
            startingUp: false,
            identityUrl: null,
            identityBackUrl: null,
            recruitmentUrl: null,
            operatorCardUrl: null,
            photoUrl: null,
            clockUrl: null,
            bankingUrl: null,
            excludedWords: null,
            recru: null,
            viewIndex: 0,
            viewerOptions: {
                "inline": true,
                "button": true,
                "navbar": false,
                "title": false,
                "toolbar": true,
                "tooltip": true,
                "movable": true,
                "zoomable": true,
                "rotatable": true,
                "scalable": false,
                "transition": false,
                "fullscreen": true,
                "keyboard": true,
            },
            fields: [
                {text: "Clock No", value: "clockNo"},
                {text: "Nationality", value: "nationality"},
                {text: "IdNo", value: "idNo"},
                {text: "Passport Number", value: "passportNumber"},
                {text: "Surname", value: "surname"},
                {text: "Name", value: "name"},
                {text: "Gender", value: "gender"},
                {text: "Position", value: "position"},
                {text: "Asylum Expiry", value: "asylumExpiry"},
                {text: "DOB", value: "dob"},
                {text: "Employee Cell No", value: "cellNo"},
                {text: "Size", value: "size"},
                {text: "Tax No", value: "taxNo"},
                {text: "Banking Details", title: true},
                {text: "Address", value: "address"},
                {text: "Bank Name", value: "bankName"},
                {text: "Acc Holder", value: "accHolder"},
                {text: "Branch", value: "branch"},
                {text: "AccNo", value: "accNo"},
                {text: "Next of Kin Particulars", title: true},
                {text: "Next of Kin", value: "nextOfKin"},
                {text: "Next of Kin Cell", value: "nextOfKinCell"},
            ],
            selectedProp: null,
            imageHeight: 0,
            totalX: 0,
            startX: null,
            totalY: 0,
            startY: null,
            nationalityOptions: [
                {id: "ZAF", description: "South Africa"},
                {id: "ZWE", description: "Zimbabwe"},
                {id: "MOZ", description: "Mozambique"},
                {id: "LSO", description: "Lesotho"},
                {id: "SWZ", description: "Swaziland"},
                {id: "MW", description: "Malawi"},
            ],
            bankOptions: [
                {id: "FNB", description: "FNB", branchCode: "250655"},
              {id: "MAKURU ACCOUNT", description: "MAKURU ACCOUNT", branchCode: "410506"},
                {id: "ABSA", description: "ABSA", branchCode: "632005"},
                {id: "AFRICAN BANK", description: "AFRICAN BANK", branchCode: "430000"},
                {id: "CAPITEC", description: "CAPITEC", branchCode: "470010"},
                {id: "STD", description: "STD", branchCode: "051001"},
                {id: "NEDBANK", description: "NEDBANK", branchCode: "198765"},
                {id: "TYMEBANK", description: "TYMEBANK", branchCode: "678910"},
                {id: "NEW PAYWALLET", description: "Open New Paywallet", branchCode: null},
                {id: "NEW ACCOUNT", description: "Open New Account", branchCode: null},
            ],
            validationRules: validationRules,
        }
    },
    watch: {
        recruitment: {
            immediate: true,
            handler(val) {
                this.refreshRecruitmentView()
            }
        },
        "viewInfo.url": {
            immediate: true,
            handler(val) {
                this.loadingImage = true
            }
        },
        loadingImage(val) {
            if (!val) {
                this.$refs.displayImageBox.style['max-width'] = this.$refs.displayImageBox.clientWidth
                this.imageHeight = this.$refs.displayImage.naturalHeight
            }
        },
        "recru.name": {
            immediate: true,
            handler() {
                try {
                    if (this.recru.surname && this.recru.name) {
                        const initials = this.recru.name.split(' ').map(word => {
                            const letters = word.split('')
                            if (!word || letters.length)
                                return letters.shift()
                            else
                                return ''
                        }).join('').toUpperCase()
                        const surname = (this.recru.surname || '').toUpperCase()
                        this.recru.accHolder = `${initials} ${surname}`
                    }
                } catch (e) {
                    console.log(e)
                }
            },
        },
        "recru.bankName": {
            immediate: true,
            handler(bankName) {
                try {
                    if (this.bankOptionsRef[bankName])
                        this.recru.branch = this.bankOptionsRef[bankName].branchCode
                } catch (e) {
                    console.log(e)
                }
            }
        },
        "recru.idNo": {
            immediate: true,
            handler(idNo) {
                try {
                    if (idNo && idNo.length === 13) {
                        const year = +(format(new Date(), 'yy'))
                        const idYear = +(idNo.substr(0,2))
                        const fullYear = (idYear > year ? '19' : '20') + idNo.substr(0,2)
                        const month = idNo.substr(2,2)
                        const day = idNo.substr(4,2)
                        this.recru.dob = `${fullYear}-${month}-${day}`
                    }
                } catch (e) {
                    console.log(e)
                }
                try {
                    if (idNo && idNo.length === 13) {
                        const genderStr = +(idNo.substr(6,4))
                        this.recru.gender = genderStr >= 5000 ? 'M' : 'F'
                    }
                } catch (e) {
                    console.log(e)
                }

            }
        },
    },
    methods: {

        getRules(prop) {
            const requiredFields = ["position", "nationality", "idNo", "passportNumber", "surname", "name", "gender", "asylumExpiry", "address", "size", "cellNo", "bankName"]
            const rules = []

            if (requiredFields.includes(prop))
                rules.push(validationRules.required)

            if (prop === 'cellNo')
                rules.push(validationRules.cellNo)

            if (prop === 'dob')
                rules.push(validationRules.sqlDateOnly)

            if (prop === 'idNo')
                rules.push(validationRules.idNo)

            if (prop === 'clockNo' && this.recruitment.fkClockDoc)
                rules.push(validationRules.required)

            if (prop === "nationality") {
                const vm = this;

                rules.push((val) => {
                    const availableNationalities = vm.nationalityOptions.map(obj => obj.id)
                    if (val && availableNationalities.includes(val))
                        return true
                    else
                        return 'Invalid Selection'
                })
            }

            if (["accNo","branch"].includes(prop) && !["NEW ACCOUNT", "NEW PAYWALLET"].includes(this.recru.bankName))
                rules.push(validationRules.required)

            return rules
        },

        mouseWheel(e) {
            this.zoomRatio = Math.min(Math.max(this.zoomRatio + (e.deltaY > 0 ? -0.1 : 0.1), 0.1), 5)
        },

        resetImage() {
            this.zoomRatio = 1;
            this.$refs.displayImage.style.left = '50%'
            this.$refs.displayImage.style.top = '50%'
        },

        mouseDownImage(e) {
            console.log(e.layerX)
            this.totalX = 0;
            this.startX = this.$refs.displayImage.style.left
            this.totalY = 0;
            this.startY = this.$refs.displayImage.style.top
            this.$refs.displayImage.style.cursor = "grabbing"
            window.addEventListener('mousemove', this.windowMove)
            window.addEventListener('mouseup', this.windowUp)
            window.addEventListener('mouseleave', this.windowUp)
        },

        windowMove(e) {
            this.totalX = this.totalX + e.movementX;
            this.$refs.displayImage.style.left = `calc(${this.startX} + ${this.totalX}px)`
            this.totalY = this.totalY + e.movementY;
            this.$refs.displayImage.style.top = `calc(${this.startY} + ${this.totalY}px)`
        },

        windowUp(e) {
            this.$refs.displayImage.style.cursor = "grab"
            window.removeEventListener('mouseup', this.windowUp)
            window.removeEventListener('mouseleave', this.windowUp)
            window.removeEventListener('mousemove', this.windowMove)
        },

        fitHeight() {
            this.$refs.displayImage.style.left = '50%'
            this.$refs.displayImage.style.top = '50%'
            this.zoomRatio = 1;
        },

        fitWidth() {
            try {
                this.$refs.displayImage.style.left = '50%'
                this.$refs.displayImage.style.top = '50%'
                this.$refs.displayImage.style.height = "auto"
                this.$refs.displayImage.style.width = "100%"
                this.$nextTick(() => {
                    this.zoomRatio = this.$refs.displayImage.clientHeight / this.$refs.displayImageBox.clientHeight
                })

            } catch (e) {
                console.log(e)
            }
        },

        noSpace(val) {
            return val.replace(/ /g, '')
        },

        onlyNumbers(val) {
            return val.replace(/[^0-9]/g, '')
        },

        noStop(val) {
            return val.replace(/\.+$/g, '')
        },

        async saveChanges() {

            if (!this.$refs.recruitment.validate())
                return this.$snack.error('Invalid/Missing Fields')


            try {
                this.savingChanges = true;
                const updated = await this.$newReq("POST", `recruitment/updateRecruitment`, {
                    id: this.recru.id,
                    name: this.recru.name,
                    surname: this.recru.surname,
                    idNo: this.recru.idNo,
                    position: this.recru.position,
                    dob: this.recru.dob,
                    address: this.recru.address,
                    nationality: this.recru.nationality,
                    taxNo: this.recru.taxNo,
                    cellNo: this.recru.cellNo,
                    size: this.recru.size,
                    bankName: this.recru.bankName,
                    accHolder: this.recru.accHolder,
                    branch: this.recru.branch,
                    accNo: this.recru.accNo,
                    gender: this.recru.gender,
                    nextOfKin: this.recru.nextOfKin,
                    nextOfKinCell: this.recru.nextOfKinCell,
                    passportNumber: this.recru.passportNumber,
                    clockNo: this.recru.clockNo,
                    asylumExpiry: this.recru.asylumExpiry,
                })
                this.$snack.info("Changes Saved")
                this.$emit('input', updated)
                console.log({updated})
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.savingChanges = false;
            }
        },

        chipClicked(string) {
            if (this.selectedProp) {
                if (this.recru[this.selectedProp])
                    this.recru[this.selectedProp] = this.recru[this.selectedProp] + " ";
                this.recru[this.selectedProp] = ((this.recru[this.selectedProp] || '') + string).trim()

                if (["passportNumber", "taxNo", "cellNo", "size", "accNo", "nextOfKinCell"].includes(this.selectedProp))
                    this.recru[this.selectedProp] = this.noSpace(this.recru[this.selectedProp])

                if (["idNo", "clockNo"].includes(this.selectedProp))
                    this.recru[this.selectedProp] = this.onlyNumbers(this.recru[this.selectedProp])

                this.recru[this.selectedProp] = this.noStop(this.recru[this.selectedProp])

                const prop = [...this.$refs[this.selectedProp]].shift()
                prop.focus()
            }
        },

        run() {
            this.$viewerApi({
                images: ['https://uploads-ssl.webflow.com/5da78276bf2098c11d5a7d4d/5da78276bf209839e15a7d6d_lightbulb%20header.png'],
            })
        },
        async refreshRecruitmentView() {
            try {
                this.startingUp = true;
                this.recru = JSON.parse(JSON.stringify(this.recruitment));
                this.identityUrl = null
                this.recruitmentUrl = null
                this.excludedWords = null
                const res = await this.$newReq('POST', `recruitment/recruitmentView`, this.recruitment)
                this.excludedWords = res.excludedWords;
                this.recruitmentUrl = res.recruitmentUrl;
                this.identityUrl = res.identityUrl;
                this.identityBackUrl = res.identityBackUrl;
                this.photoUrl = res.photoUrl;
                this.bankingUrl = res.bankingUrl;
                this.clockUrl = res.clockUrl;
                this.operatorCardUrl = res.operatorCardUrl;
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
                this.shownRelay = false
            } finally {
                this.startingUp = false;
                setTimeout(() => {
                    this.$refs.recruitment.validate()
                }, 500)
            }
        },

        async removeWord(word) {
            try {
                console.log(this.viewInfo.data.documentType)
                if (!this.excludedWords[this.viewInfo.data.documentType])
                    this.excludedWords[this.viewInfo.data.documentType] = []
                this.excludedWords[this.viewInfo.data.documentType].push(word)

                this.excludedWords = await this.$newReq('POST', `recruitment/addExcludedWord`, {
                    docType: this.viewInfo.data.documentType,
                    str: word
                })
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            }
        }
    },
    computed: {
        jobDescriptions() {
            return this.$store.getters.jobDescriptionNames
        },
        bankOptionsRef() {
            return objectifyArr(this.bankOptions, 'id')
        },
        fieldsToUse() {
            const fieldsToUse = [...this.fields]

            if (this.recru.nationality === "ZAF") {
                arrSplice(fieldsToUse, field => field.value === "passportNumber")
                arrSplice(fieldsToUse, field => field.value === "asylumExpiry")
            } else if (this.recru.nationality && this.recru.nationality !== "ZAF")
                arrSplice(fieldsToUse, field => field.value === "idNo")

            return fieldsToUse
        },
        showDownloadRelay: {
            get() {
                return this.showDownload
            },
            set(val) {
                this.$emit('update:showDownload', val)
            }
        },
        metaInfo() {



            const strings = (this.viewInfo.data.metaInfo || '').split(/\n/).map(str => str.trim())
            const existingValues = this.fields.reduce((list, field) => {
                if (this.recru[field.value])
                    list.push(this.recru[field.value])
                return list
            }, [])

            return strings
                    .map(str => {
                        const chars = str.split("")
                        if (chars.length && chars[0] === "-")
                            chars.splice(0, 1)
                        if (chars.length)
                            chars[0] = chars[0].toUpperCase()
                        return chars.join("")
                    })
                    .filter(str => !existingValues.includes(str))
                    .filter(str => {
                        if (!this.excludedWords[this.viewInfo.data.documentType])
                            return true
                        else
                            return !this.excludedWords[this.viewInfo.data.documentType].includes(str.trim())
                    })

        },
        viewInfo() {
            console.log("RECALC", this.recruitment, this.curTab)
            switch (this.curTab) {
                case "idDoc":
                    return {url: this.identityUrl, data: this.recruitment.idDoc}
                case "recruitmentDoc":
                    return {url: this.recruitmentUrl, data: this.recruitment.recruitmentDoc}
                case "photoDoc":
                    return {url: this.photoUrl, data: this.recruitment.photoDoc}
                case "bankingDoc":
                    return {url: this.bankingUrl, data: this.recruitment.bankingDoc}
                case "clockDoc":
                    return {url: this.clockUrl, data: this.recruitment.clockDoc}
                case "idDocBack":
                    return {url: this.identityBackUrl, data: this.recruitment.idDocBack}
                case "operatorCard":
                    return {url: this.operatorCardUrl, data: this.recruitment.operatorCard}
                default:
                    return null;
            }
        },
        curTab() {
            const list = [
                    "idDoc",
                    "recruitmentDoc",
                    "photoDoc",
            ];
            if (this.recruitment.fkBankingDoc) list.push("bankingDoc")
            if (this.recruitment.fkClockDoc) list.push("clockDoc")
            if (this.recruitment.fkIdDocBack) list.push("idDocBack")
            if (this.recruitment.fkOperatorCard) list.push("operatorCard")

            return list[this.viewIndex]
        },
        shownRelay: {
            get() {
                return this.shown
            },
            set(val) {
                this.$emit('update:shown', val)
            }
        },
        zoomRatio: {
            get() {
                return this.$store.state.zoomRatio
            },
            set(val) {
                this.$store.state.zoomRatio = val
            }
        }
    },
}
</script>

<style scoped>

</style>